import { useState, useEffect } from "react"

export function usePWA() {
    const [isPWA, setIsPWA] = useState(
        window.matchMedia("(display-mode: standalone)").matches
        || (window.navigator as any).standalone === true
    )

    useEffect(() => {
        const handler = (e: MediaQueryListEvent) => setIsPWA(e.matches)
        const mediaQuery = window.matchMedia("(display-mode: standalone)")
        mediaQuery.addEventListener("change", handler)
        return () => mediaQuery.removeEventListener("change", handler)
    }, [])

    return { isPWA }
}